import { Link } from 'react-router-dom';

const BASE =
  'group inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full font-semibold transition-[transform,background-color,color,border-color,box-shadow] duration-300 ease-out active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-60 disabled:active:scale-100';

const VARIANTS = {
  primary: 'bg-accent text-white shadow-accent hover:-translate-y-0.5 hover:bg-accent-hover',
  secondary: 'border border-line-strong bg-surface text-ink hover:-translate-y-0.5 hover:border-ink/40',
  inverse: 'bg-white text-accent-deep shadow-lift hover:-translate-y-0.5',
  ghost: 'text-ink hover:bg-ink/5'
};

const SIZES = {
  sm: 'h-10 px-4 text-sm',
  md: 'h-11 px-5 text-[15px]',
  lg: 'h-12 px-6 text-base sm:h-[52px] sm:px-7'
};

function LinkButton({
  to,
  href,
  variant = 'primary',
  size = 'md',
  className = '',
  children,
  ...rest
}) {
  const classes = `${BASE} ${VARIANTS[variant]} ${SIZES[size]} ${className}`;

  if (to) {
    return (
      <Link to={to} className={classes} {...rest}>
        {children}
      </Link>
    );
  }

  if (href) {
    return (
      <a href={href} className={classes} target="_blank" rel="noreferrer" {...rest}>
        {children}
      </a>
    );
  }

  return (
    <button type="button" className={classes} {...rest}>
      {children}
    </button>
  );
}

export default LinkButton;
